import { Component, OnInit } from '@angular/core'
import { LimitedQueue, Queue } from '../../../../helpers'

import { QuestionTypeView, QuestionViewService, IQuestionAnswer } from '../'

@Component({
  selector: 'mp-multi-select-question-view',
  templateUrl: './multi-select-question-view.html'
})
export class MultiSelectQuestionViewComponent extends QuestionTypeView implements OnInit {

  public selectStrategies = []

  private _selectStrategyMap = {
    '7': [this._sentenceSelectCustomSelectStrategy.bind(this)]
  }

  public constructor(
    _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

  public ngOnInit() {
    this.selectStrategies = this._getSelectStrategy()
  }

  public onOptionSelected(questionAnswers: IQuestionAnswer[]) {
    this._questionViewService.questionAnswered.emit(questionAnswers)
  }

  private _getSelectStrategy() {
    const topic = this.question.majorTopic ? this.question.majorTopic : { category: null }
    const categoryId = topic.category ? topic.category.id : ''
    return this._selectStrategyMap[categoryId] || []
  }

  private _sentenceSelectCustomSelectStrategy(answerChoiceFormGroup, choiceIndex, context) {
    context.queue = context.queue || this._createGroupQueue(answerChoiceFormGroup)
    const selectedChoice = answerChoiceFormGroup[choiceIndex]
    const selectedKey = Object.keys(selectedChoice)[0]

    if (selectedChoice[selectedKey]) {
      context.queue.enqueue(selectedChoice)
    } else {
      context.queue = this._createGroupQueue(answerChoiceFormGroup)
    }

    answerChoiceFormGroup.forEach((group) => {
      const key = Object.keys(group)[0]
      group[key] = context.queue.includes(group) ? true : false
    })
  }

  private _createGroupQueue(answerChoiceFormGroup) {
    const queue = new LimitedQueue(2)
    answerChoiceFormGroup.forEach((formGroup, index) => {
      if (Object.values(formGroup)[0]) {
        queue.enqueue(formGroup)
      }
    })
    return queue
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/multi-select-question-view/multi-select-question-view.component.ts